export type UserDataObject = {
  ID            ?: string,
  productFinding?: string,
  visitorID     ?: string,
};

export type UserDataCompleteUserObject = {
  loggedIN       : boolean,
  emarsysID     ?: string,
  ID            ?: string,
  productFinding?: string,
  visitorID     ?: string,
}